import type { TableColumn } from '@ipfabric/utils';

export const hasColumnLoadedDependencies = (
  column: TableColumn<any>,
  row: unknown,
): boolean =>
  !!row &&
  column.webDependencies.every((prop) => (row as any)[prop] !== undefined);
